/* ============================================================
   darulkitab — UI/UX enhancement layer
   - Scroll reveal (fade + rise) for content sections and cards
   - Back-to-top button
   Progressive & safe: if this script never runs, or the user
   prefers reduced motion, all content stays visible and static.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    // Only auto-reveal whole sections on presentational templates (home + pages),
    // never on product/collection/cart where transforms could touch sticky UI.
    var main = document.getElementById('MainContent');
    var tpl = (main && main.getAttribute('data-template')) || '';
    var allowSectionReveal = /^(index|page)/.test(tpl);

    var targets = [];
    var seen = new Set();
    function add(el) {
      if (el && !seen.has(el)) {
        seen.add(el);
        targets.push(el);
      }
    }

    document.querySelectorAll('.dk-reveal').forEach(add);
    if (allowSectionReveal) {
      document.querySelectorAll('#MainContent .shopify-section').forEach(function (el) {
        el.classList.add('dk-reveal');
        add(el);
      });
    }

    if (!targets.length) return;

    // Turning on the hidden starting state now, right before we reveal — so a
    // failed/blocked script can never leave content invisible.
    root.classList.add('dk-js');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dk-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    targets.forEach(function (el) {
      // Anything already in (or just below) the viewport reveals immediately — no flash.
      if (el.getBoundingClientRect().top < viewport * 0.95) {
        el.classList.add('dk-revealed');
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    if (document.querySelector('.dk-to-top')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dk-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);

    var shown = false;
    var ticking = false;
    function update() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var should = y > 600;
      if (should !== shown) {
        shown = should;
        btn.classList.toggle('dk-to-top--visible', should);
      }
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  function init() {
    initReveal();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
